import React from 'react';
import { Field } from 'redux-form';

import Default from 'components/Input/Default';
import Label from 'components/Label';
import { LOGIN_INPUT_PREFIX } from 'constants/Global';
import { translate } from 'helpers/Translate';

/**
 * RetrievePhone Functional Component.
 */
export default function RetrievePhone() {
    return (
        <div data-step-retrieve-phone>
            <div className="update-contact-fields">
                <div className="update-contact-field">
                    <Label labelFor={`${LOGIN_INPUT_PREFIX}firstname`} text={translate('Prénom')} />
                    <Field
                        containerClassName="margin-top"
                        component={Default}
                        name={`${LOGIN_INPUT_PREFIX}firstname`}
                        placeholder={translate('Prénom')}
                        fullWidth
                        autoComplete="given-name"
                    />
                </div>

                <div className="update-contact-field">
                    <Label labelFor={`${LOGIN_INPUT_PREFIX}lastname`} text={translate('Nom')} />
                    <Field
                        containerClassName="margin-top"
                        component={Default}
                        name={`${LOGIN_INPUT_PREFIX}lastname`}
                        placeholder={translate('Nom')}
                        fullWidth
                        autoComplete="family-name"
                    />
                </div>
            </div>

            <div className="update-contact-fields">
                <div className="update-contact-field">
                    <Label
                        labelFor={`${LOGIN_INPUT_PREFIX}cell_phone`}
                        text={translate('Téléphone')}
                    />
                    <Field
                        containerClassName="margin-top"
                        component={Default}
                        type="tel"
                        name={`${LOGIN_INPUT_PREFIX}cell_phone`}
                        placeholder={translate('Téléphone')}
                        fullWidth
                        autoComplete="tel"
                    />
                </div>
                <div
                    className="update-contact-field update-contact-info"
                    data-update-contact-info-text
                >
                    <span className="icon-info_outline update-contact-info__icon" />
                    <p className="update-contact-info__text">
                        {translate('Nos équipes pourraient vous contacter dans le cadre d’une ')}{' '}
                        <strong>{translate('enquête de satisfaction')}</strong>{' '}
                        {translate('sur nos estimations.')}
                        <br />
                        {translate('Vos coordonnées ne seront ')}{' '}
                        <strong>{translate('jamais transmises à nos partenaires')}</strong>{' '}
                        {translate('ou autres tiers sans votre autorisation.')}
                    </p>
                </div>
            </div>
        </div>
    );
}

RetrievePhone.displayName = 'RetrievePhone';
